export const DEFAULT_DISPLAY_COUNTRY_CODE = "+91"

const LOCAL_PHONE_DIGITS = 10

/**
 * Display-only: prefix a bare 10-digit number with the default country code ("9876543210" -> "+91 9876543210").
 * Values that already carry a country code ("+..." or "91" + 10 digits) or don't look like a local number are left as-is.
 */
export const formatPhoneForDisplay = (raw?: string | number | null): string => {
    const value = String(raw ?? "").trim()
    if (!value || value.startsWith("+")) return value

    const digitsOnly = value.replace(/\D/g, "")
    if (digitsOnly.length === LOCAL_PHONE_DIGITS) return `${DEFAULT_DISPLAY_COUNTRY_CODE} ${digitsOnly}`
    return value
}
